import React from 'react'
import { lu } from '../../data/reportData';
import { TITLE, TAB, H1, H1_TX, H2, H2_1, TB_LIST, TXB, TXR, TXR_B, TXR_B1, TXR_I, TXR_II, TXC, TXC_B, TXC_B1, TX_B, TX_BI, TXC_I, TXC_I1, CK, CK_H2, CK1, CK1_I, YN, YN1, TCH, IMAGE_SC } from "../../styles/urar-styles";
import { IMAGE, IMAGE_1, COMMENTARY, EXHIBITS, TABLE, TITLE_ADD, SUM_HD, SIG_B, TB_SCA_SUB_H1, TB_SUB_H1_R, TB_SCA_H2 } from "../../styles/urar-styles";
import { LIST_FIELDS, LIST_IMAGE_ROW, LIST_SINGLE_ROW } from './SalesComparisonApproach';

export default function INCOME_APPROACH() {
	if (!(global.ptr.sowDetail.incomeApproachIndicator)) return undefined;

	return (
		<>
		<TAB title="Income Approach" />

		<GRM_COMPARABLE_PAGES />


		<H1 title="Indicated Value by Income Approach" />
		<table className="table-fixed mpb text-center">
			<thead className="border-b-[1px] border-black">
				<tr>
					<th className='w-[343px]'>Total Monthly Market Rent</th>
					<th className='w-[25px]'>X</th>
					<th className='w-[343px]'>Gross Rent Multiplier</th>
					<th className='w-[25px]'>X</th>
					<th className='w-[344px]'>Indicated Value by Income Approach</th>
				</tr>
			</thead>
			<tbody className="border-b-[1px] border-black">
				<tr>
					<td>{lu("24.022")}</td>
					<td />
					<td>{lu("24.023")}</td>
					<td />
					<td>{lu("24.024")}</td>
				</tr>
			</tbody>
		</table>

		<COMMENTARY title="Income Approach Commentary" value={lu("24.025")} />
		<EXHIBITS title="Income Approach Exhibits" values={lu("24.099")} />
		</>
	)
}

function GRM_COMPARABLE_PAGES() {
	let numComps = global.ptr.compMultList.length;
	let pages = [];
	for (let i = 0; i < numComps; i += 3)
			pages.push(Math.floor(i / 3));

	return (
		<>
		{
			pages.map((p, i) => {
				return (
					<GRM_COMPARABLES key={i} page={p} numComps={numComps} />
				)
			})
		}
		</>
	)
}

function GRM_COMPARABLES({page, numComps}) {
	let titles = [];
	titles.push("");
	titles.push("Subject Property");
	let widths = [];
	widths.push(216);
	widths.push(216);

	let cn = (page * 3) + 1; // starting comp number
	for (let ix = cn; ix < cn+3 && ix <= numComps; ++ix) {
		titles.push("Comparable #" + ix.toString());
		widths.push(216);
	}

	let end = (page * 3) + 2;
	if (end > numComps) end = numComps;
	let width = 216 * (widths.length);

	let continued = (page > 0);

	return (
		<>
			<H1 title="Gross Rent Multiplier Comparables" />
			<TCH titles={titles} widths={widths} centered />

			<LIST_SINGLE_ROW page={page} values={lu("22.001.1")}  />
			<LIST_IMAGE_ROW page={page} values={lu("22.001.2")} />
			<LIST_FIELDS page={page} values={lu("24.010-21")} />


		</>
	)

}
